import { Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import NewModal from '../NewModal';
import RobotFindSelectForm from '../RobotFindSelectForm';

const MessageSearchModal = ({ open, items, onUpdate, onCancel }) => {
  const matches = useMediaQuery('(max-width:600px)');

  const [selectedItems, setSelected] = useState([]);
  const [search, setSearch] = useState('');
  const [searchResult, setSearchResult] = useState(items);

  const onItemSelectClick = ({ id }) => {
    const newItems = [...selectedItems];
    const selected = items.find(({ id: robotId }) => robotId === id);

    if (selected) {
      newItems.push(selected);
      setSelected(newItems);
      setSearchResult(searchResult.filter((item) => !newItems.includes(item)));
    }
  };

  const onItemDeselectClick = (id) => {
    const newItems = selectedItems.filter((item) => item.id !== id);
    setSelected(newItems);
    setSearchResult(items.filter((item) => !newItems.includes(item)));
  };

  const onSearchChange = (e) => {
    const { value } = e.target;
    setSearch(value);
    const result = [...items].reduce((prev, curr) => {
      const { serial, group, alias, id } = curr;
      const searchValue = new RegExp(value, 'ig');
      if (
        (serial && serial.search(searchValue) > -1) ||
        (group && 'name' in group && group.name.search(searchValue) > -1) ||
        (alias && alias.search(searchValue) > -1)
      ) {
        prev.push({
          id,
          serial,
          group,
          alias,
          checked:
            selectedItems.findIndex(({ id: robotId }) => robotId === id) > -1,
        });
      }
      return prev;
    }, []);
    setSearchResult(result);
  };

  const buttons = [
    { label: '취소', onClick: onCancel },
    {
      label: '선택 완료',
      onClick: () => onUpdate(selectedItems),
    },
  ];

  return (
    <NewModal open={open} buttons={buttons} onClose={onCancel}>
      <Grid container spacing={1} sx={{ width: matches ? '100%' : '600px' }}>
        <Grid item xs={12}>
          <Typography variant="h5">로봇 검색 및 선택</Typography>
        </Grid>
        <RobotFindSelectForm
          {...{
            selected: selectedItems,
            onChange: onSearchChange,
            input: search,
            onSelect: onItemSelectClick,
            onDeselect: onItemDeselectClick,
            list: searchResult,
          }}
        />
      </Grid>
    </NewModal>
  );
};

export default MessageSearchModal;
